export default __webpack_public_path__ + "static/media/submit_icon.0217da00.svg";